import type { ComponentsAfterpayWidget } from 'queries/graphql';
import { useTextFontOverrides } from 'utils/font-override';
import { buildCssVar } from 'utils/style-override';

import styles from './styles.module.scss';

export default function AfterpayWidget({
  price,
  currency,
  badgeTheme,
  modalTheme,
  textColor,
  textFont,
}: ComponentsAfterpayWidget & {
  price: number;
  currency: string;
}) {
  const textFontOverrides = useTextFontOverrides(textFont);

  return (
    <div className={`root ${styles.container}`}>
      <style jsx>
        {`
          .root {
            ${buildCssVar('--text-color', textColor, 'var(--text-color-dark)')}
            ${textFontOverrides ?? ''}
          }
        `}
      </style>

      {/* @ts-ignore */}
      <afterpay-placement
        data-locale="en_US"
        data-currency={currency}
        data-amount={price}
        data-badge-theme={badgeTheme}
        data-modal-theme={modalTheme}
      />
    </div>
  );
}
